import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { Befehl33 } from '../../../models'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { useBefehlForm } from '../../../hooks'
import {
  convertBefehl33FormDataToModel,
  convertModelToBefehl33FormData
} from './converters'
import { Befehl33FormData, createBefehl33FormValidationSchema } from './schema'
import Auftrag33_10Form from './Auftrag33_10Form'

export default function Befehl33Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-33-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl33>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl33FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl33FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl33FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl33FormData) => {
      const updatedBefehl = convertBefehl33FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl33FormData>
      befehlKennung="33"
      title={t('befehle.33.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      <Auftrag33_10Form
        readOnly={readOnly}
        fieldPrefix="auftrag33_10"
        data-testid={`${testId}-auftrag-33-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
